module.exports = __webpack_public_path__ + "media/images/consumer/components/progress-bar/step-04@2x-f92d81b1f82deafb564ade270eaa1070.webp";